/** localStorage helpers: show pricing promo at most once per local calendar day per user. */

const PRICING_PROMO_SHOWN_PREFIX = 'pricingPromoLastShownDate';

export function getLocalDateKey(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function storageKeyForUser(userId) {
  const id = userId != null && String(userId).trim() !== '' ? String(userId) : 'anon';
  return `${PRICING_PROMO_SHOWN_PREFIX}:${id}`;
}

export function hasSeenPricingPromoToday(userId) {
  if (typeof localStorage === 'undefined') return true;
  try {
    return localStorage.getItem(storageKeyForUser(userId)) === getLocalDateKey();
  } catch {
    return true;
  }
}

export function markPricingPromoShownToday(userId) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(storageKeyForUser(userId), getLocalDateKey());
  } catch (_) {}
}
